export function propertyDetails(id) {
  if (id === "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35")
    return {
      id: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
      name: "Przykład kosztów",
      transactions: [
        {
          id: "a156acb6-c551-4f2f-916a-033a893b7af5",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-02-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "a6ad9bb8-18ea-447b-9bc4-072b74a88672",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-05-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "37ba670f-7828-474c-93f9-07407f6b75fb",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-08-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "b3597dca-0a7e-48e6-8253-097070e820e7",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-10-01T00:00:00",
          value: 513.32,
          details: null,
        },
        {
          id: "9c376884-47e7-416b-a596-14da094d5fc6",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2022-02-03T00:00:00",
          value: 134.5,
          details: null,
        },
        {
          id: "c377ef97-9ae5-4362-a4d9-1921fa0b7559",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-06-04T00:00:00",
          value: 121.85,
          details: null,
        },
        {
          id: "3592b761-3fa5-48ce-b327-1a65061d3545",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "0337ccb9-3968-4626-b95f-012e76911056",
          date: "2021-01-13T00:00:00",
          value: 50000.0,
          details: null,
        },
        {
          id: "ec071e77-71e0-4ad2-85af-1ccda4ad267d",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-10-05T00:00:00",
          value: 102.34,
          details: null,
        },
        {
          id: "1b097ec8-1c39-42c7-96b7-24bc116a2284",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2022-02-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "97e93cd7-9251-4787-a66b-29c2336da423",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2022-02-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "2c7673cd-69f7-479e-80ca-32651bae5206",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "87a8f330-4071-475d-b8c9-2522a797cde5",
          date: "2021-01-15T00:00:00",
          value: 40000.0,
          details: null,
        },
        {
          id: "9b710ef7-e7e5-464d-9bf7-38a97c79deb1",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-03-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "3d810de8-3deb-4a4b-8495-3b11bdca1a0f",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-02-04T00:00:00",
          value: 120.67,
          details: null,
        },
        {
          id: "d58489b4-71dc-4dfb-8ed5-3d09c05a6e1c",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-12-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "75a7056a-5b53-4742-a888-4a560aca3258",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-09-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "22d70da7-a234-4c5d-87a1-4ac686a5c6fb",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-07-06T00:00:00",
          value: 130.1,
          details: null,
        },
        {
          id: "3fa37017-954b-4ce1-90c7-4c62a52a706f",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-04-07T00:00:00",
          value: 109.99,
          details: null,
        },
        {
          id: "7a0a022c-f3c2-480a-ae1b-4e2049523484",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-03-04T00:00:00",
          value: 116.21,
          details: null,
        },
        {
          id: "737e4276-5bb4-4041-a9f9-4f132f0a49ab",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-11-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "616cfde4-a693-4fda-8f84-51792a436a71",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-12-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "102ce96f-1c75-4a0b-8023-58778c9c39df",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-10-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "eb362e80-214b-4943-9398-5b957fbab172",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-11-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "8aa05783-8ded-4f24-8a78-5cdc0354cc2c",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-05-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "2bb3c014-586e-4627-b820-5e82d86f4013",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "846308a1-1953-4f9d-bbdc-e158448536d2",
          date: "2022-01-19T00:00:00",
          value: 98.3,
          details: null,
        },
        {
          id: "99327687-a275-4174-9331-6033d828c6f4",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2022-01-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "2b93d957-32a7-44de-8961-61ab048e8c51",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-09-07T00:00:00",
          value: 111.11,
          details: null,
        },
        {
          id: "87098eaf-ff5d-4994-945e-669eb4d55bcc",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-04-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "4bf5924c-4ee4-476a-bb45-6c4bd17093f9",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2022-01-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "3036741c-1e78-4dc6-a96b-6f4356567e63",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-10-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "fa67a53c-3ca8-4d48-8d1e-742659d94de8",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-02-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "d09579b4-4817-4a5f-9cea-76de5a38fa21",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-03-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "369a00e5-d326-4b9c-938c-7eaf8fcda468",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-04-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "9ccb90b5-7a42-4cc4-b6da-85bac4fc4cc0",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "ffab06c0-5136-49b2-bd8c-a326cbbd3fdb",
          date: "2022-01-01T00:00:00",
          value: 90.0,
          details: null,
        },
        {
          id: "1d22c79b-c157-4766-8887-8d91463c7b33",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-08-04T00:00:00",
          value: 101.89,
          details: null,
        },
        {
          id: "41588e50-a4f9-4263-82fc-8f0be849a436",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2022-01-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "d3341dcc-f8f4-432a-979d-9184579646d8",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-02-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "37102a8e-a560-4f4f-8f2e-936f9fa58357",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2022-01-05T00:00:00",
          value: 138.32,
          details: null,
        },
        {
          id: "7bcc2b18-803d-4c5a-ad04-940b02a22315",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-09-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "db8715dc-30ca-4331-9591-9f412e4b7c54",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-01-01T00:00:00",
          value: 100000.0,
          details: null,
        },
        {
          id: "66e873d5-c4ea-4be3-8972-9faf398140bf",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-07-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "d77ed7f7-e17f-46ba-b734-a44215d94efa",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-02-01T00:00:00",
          value: 3000.0,
          details: "prowizja",
        },
        {
          id: "3f30d65c-1a01-4749-b593-a50e81d39cd2",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-03-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "b419d07a-9322-4b4d-81cb-ae81c39353b0",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5a1ba3c4-4571-478e-955f-cc7fdcbac9f3",
          date: "2022-01-03T00:00:00",
          value: 245.87,
          details: null,
        },
        {
          id: "a13b7225-eade-48e5-ac47-af546ad4e73d",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-12-03T00:00:00",
          value: 140.12,
          details: null,
        },
        {
          id: "d8fd1c5e-038d-4f42-9adb-bef44377a68e",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-12-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "8a5cee80-a1ad-4fb8-a157-c31144069df0",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-05-05T00:00:00",
          value: 128.32,
          details: null,
        },
        {
          id: "c811dada-2ebb-45e0-93f0-c4a00d873d75",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
          date: "2021-11-03T00:00:00",
          value: 123.45,
          details: null,
        },
        {
          id: "2e53079d-de12-4cdf-97cd-c88a151fc1f3",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-11-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "fb68ac91-461c-42c5-843b-cba023d7ca67",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-08-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "d5f4a033-5fd7-4d85-94ce-cbfea6f3caa2",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-07-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "e727d8f9-f319-4e22-9ef4-d0e1ba7b60b2",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "ffab06c0-5136-49b2-bd8c-a326cbbd3fdb",
          date: "2022-02-01T00:00:00",
          value: 90.0,
          details: null,
        },
        {
          id: "9af5d6dd-72f8-44a6-8122-d97b9710de4a",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-09-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "e314c40d-3dd0-47e7-b527-da4805927853",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-06-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "c4cce340-85af-45ed-9599-e112dffab63e",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-06-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "a1b656ac-90ae-46e9-88f8-f2f8063860a3",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-12-07T00:00:00",
          value: 123.33,
          details: "rozliczenie mediów",
        },
        {
          id: "fbf8a9fb-d6f0-4a4c-821a-f3a2b68355cf",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-06-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "eda2596e-e278-4ce7-837f-f4e2575bafb0",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "87a8f330-4071-475d-b8c9-2522a797cde5",
          date: "2022-01-18T00:00:00",
          value: 3499.99,
          details: "nowy TV",
        },
        {
          id: "446320bc-a41d-4d62-8cf6-f6294d600beb",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-05-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "ae31a523-2512-4d9c-a991-f6535390014b",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2022-02-01T00:00:00",
          value: 1000.0,
          details: null,
        },
        {
          id: "42961563-93a7-465a-8072-f683c7f0ffe9",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
          date: "2021-04-01T00:00:00",
          value: 500.0,
          details: null,
        },
        {
          id: "8c440c3d-0c45-4b62-8ae7-f8f2bdd6a228",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-07-01T00:00:00",
          value: 400.0,
          details: null,
        },
        {
          id: "5c6d9236-742f-44e0-af41-fc723d928df4",
          propertyId: "42f8e10b-cd67-4ca5-8e65-1eb5b9195b35",
          categoryId: "e4371316-608a-4ead-a1e9-e763385f6ae8",
          date: "2021-08-01T00:00:00",
          value: 400.0,
          details: null,
        },
      ],
      categories: categories,
      isActive: true,
    };
  if (id === "6a672a64-835f-4c5b-88ce-a10260f5569a")
    return {
      id: "6a672a64-835f-4c5b-88ce-a10260f5569a",
      name: "Przykład wynajmu",
      transactions: [
        {
          id: "efaa8522-9be6-4b38-bf08-100a47464448",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2022-01-01T12:21:27",
          value: 2500.0,
          details: null,
        },
        {
          id: "d93e8f5e-8af0-4296-bd53-11038781a8fe",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-10-01T11:20:03",
          value: 200.0,
          details: null,
        },
        {
          id: "0377ae66-eb04-4d77-862a-18a8117c5601",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-03-01T12:12:02",
          value: 2500.0,
          details: null,
        },
        {
          id: "689a83fc-fcbc-4bf5-84f2-19094626450b",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-09-01T11:19:30",
          value: 2500.0,
          details: null,
        },
        {
          id: "d45da52a-4c2e-4d1e-8f17-1bdacabcd81d",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-07-01T11:18:02",
          value: 200.0,
          details: null,
        },
        {
          id: "08b24342-f0c3-4a52-b7af-25f187c4621b",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-08-01T11:18:44",
          value: 2500.0,
          details: null,
        },
        {
          id: "f93d9a30-c423-457f-afa8-32553a62cb83",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-07-01T11:17:44",
          value: 2500.0,
          details: null,
        },
        {
          id: "f4ae5a4e-46b2-47b5-9975-519032e9abaf",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-04-01T11:13:09",
          value: 2500.0,
          details: null,
        },
        {
          id: "a8b49014-af5f-4b15-9a7d-55267c08c348",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-12-01T12:21:02",
          value: 2500.0,
          details: null,
        },
        {
          id: "ff54b184-ea6e-4e64-8427-5a6d4080ab2c",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "87a8f330-4071-475d-b8c9-2522a797cde5",
          date: "2021-07-16T11:18:21",
          value: 2000.0,
          details: null,
        },
        {
          id: "7483c2fc-0f22-4d09-bbee-5ce338f55c1b",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-06-01T11:17:16",
          value: 2500.0,
          details: null,
        },
        {
          id: "c297ff26-f4ad-4c05-8d2b-628fb819adcb",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-11-01T12:20:28",
          value: 2500.0,
          details: null,
        },
        {
          id: "e90b9394-dc51-459e-bbf3-65a8fec87ea2",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-03-01T12:12:53",
          value: 200.0,
          details: null,
        },
        {
          id: "cbc5e5c9-2e04-4bef-b77f-695370c8d903",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-09-01T11:19:42",
          value: 200.0,
          details: null,
        },
        {
          id: "7432a4bf-b730-4e9f-8943-7ae21293e9ac",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-12-01T12:21:15",
          value: 200.0,
          details: null,
        },
        {
          id: "71aa9a32-7623-410f-bb70-7f3e12e4ce6d",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2022-01-01T12:21:39",
          value: 200.0,
          details: null,
        },
        {
          id: "cac89a6d-e0cd-4ffb-be00-880476a3a457",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-01-01T11:09:19",
          value: 200.0,
          details: null,
        },
        {
          id: "40abd213-acfc-4432-8bfb-889ecc334162",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "0337ccb9-3968-4626-b95f-012e76911056",
          date: "2021-01-05T11:09:37",
          value: 10000.0,
          details: null,
        },
        {
          id: "d48ab175-c739-4230-9d8f-8d85bd767247",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "846308a1-1953-4f9d-bbdc-e158448536d2",
          date: "2021-12-15T12:22:12",
          value: 300.0,
          details: null,
        },
        {
          id: "3248c238-3345-406b-90fc-9bf3a7af0585",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-04-01T11:14:24",
          value: 200.0,
          details: null,
        },
        {
          id: "4258cbf5-145f-43af-a32f-9d83871b74ff",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-05-01T11:16:15",
          value: 200.0,
          details: null,
        },
        {
          id: "cb267e79-d0c0-449e-a6be-9ff02665f802",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "94c7dad3-f264-480e-ac9f-32009a5e641f",
          date: "2022-02-15T00:00:00",
          value: 323.0,
          details: "",
        },
        {
          id: "e25b98e2-3bd8-4c47-afe3-a901c3b3b7f6",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-08-01T11:19:14",
          value: 200.0,
          details: null,
        },
        {
          id: "b7dc061d-1189-4507-bd6f-ad327507e8f5",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-02-01T09:56:32",
          value: 2500.0,
          details: null,
        },
        {
          id: "1275f8ee-be19-472b-b44e-aea22b46e072",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-11-01T12:20:51",
          value: 200.0,
          details: null,
        },
        {
          id: "1948d75a-bea1-4fb5-a80c-b5d97edf3336",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-05-01T11:14:50",
          value: 2500.0,
          details: null,
        },
        {
          id: "1ea23e15-d3a9-4a2d-9e16-c2591e703fbd",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
          date: "2021-01-01T08:54:11",
          value: 350000.0,
          details: null,
        },
        {
          id: "84a05bb4-386d-4667-afb4-c92cf11a541e",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "87a8f330-4071-475d-b8c9-2522a797cde5",
          date: "2022-01-18T00:00:00",
          value: 1500.0,
          details: "",
        },
        {
          id: "e5849a0f-fbdf-4b62-9833-cf235bc800f1",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2022-02-01T12:21:48",
          value: 2500.0,
          details: null,
        },
        {
          id: "2ec597f3-ae3f-4b45-a81f-d39756b8f22f",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-06-01T11:17:32",
          value: 200.0,
          details: null,
        },
        {
          id: "72780e27-5edf-49a4-ac6e-ded26eea05a0",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
          date: "2021-10-01T11:19:51",
          value: 2500.0,
          details: null,
        },
        {
          id: "7ddefb98-e849-4ff3-b8ef-ecc9da6fd9d3",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2021-02-01T11:10:05",
          value: 200.0,
          details: null,
        },
        {
          id: "748dfff7-55ff-4361-9fd0-ffc85799abea",
          propertyId: "6a672a64-835f-4c5b-88ce-a10260f5569a",
          categoryId: "455cf972-1a82-488c-911a-e483feebd110",
          date: "2022-02-01T00:00:00",
          value: 200.0,
          details: "",
        },
      ],
      categories: categories,
      isActive: true,
    };
}

const categories = [
  {
    id: "0337ccb9-3968-4626-b95f-012e76911056",
    name: "Remont",
    type: "renovation",
    isCost: true,
  },
  {
    id: "cea3dbbc-fc58-495f-aa2a-08226b092133",
    name: "Inny przychód",
    type: "otherIncome",
    isCost: false,
  },
  {
    id: "70373d47-3512-4e1a-a755-195cfd3884af",
    name: "Formalności",
    type: "formalities",
    isCost: true,
  },
  {
    id: "87a8f330-4071-475d-b8c9-2522a797cde5",
    name: "Wyposażenie",
    type: "equipment",
    isCost: true,
  },
  {
    id: "94c7dad3-f264-480e-ac9f-32009a5e641f",
    name: "Podatek dochodowy",
    type: "tax",
    isCost: true,
  },
  {
    id: "3f76d465-e086-4488-b8ae-3f63b7d17c63",
    name: "Zakup nieruch.",
    type: "buy",
    isCost: true,
  },
  {
    id: "2d247652-88ab-465c-813b-451922571bf1",
    name: "Woda",
    type: "water",
    isCost: true,
  },
  {
    id: "76d1d2e5-f9b1-4f5a-9524-49abb8f4177b",
    name: "Ogrzewanie",
    type: "heat",
    isCost: true,
  },
  {
    id: "ce140315-b52b-4b9e-9044-5a22f3fb6d19",
    name: "Garaż",
    type: "garage",
    isCost: true,
  },
  {
    id: "73c20a42-6c2c-4d21-abad-5c786ee8f9d8",
    name: "Gaz",
    type: "gas",
    isCost: true,
  },
  {
    id: "7615189b-3bef-4688-8298-93ec089ea6f2",
    name: "Ochrona",
    type: "security",
    isCost: true,
  },
  {
    id: "5a9b3257-a83d-4ca8-ac76-95ba2534bdac",
    name: "Przeglądy",
    type: "reviews",
    isCost: true,
  },
  {
    id: "ffab06c0-5136-49b2-bd8c-a326cbbd3fdb",
    name: "Internet&TV",
    type: "internetTv",
    isCost: true,
  },
  {
    id: "84a9c6f3-60c8-4476-8bb2-b4997e4c8708",
    name: "Prąd",
    type: "electricity",
    isCost: true,
  },
  {
    id: "d692641a-46af-45b4-bc8d-c212a33e44c3",
    name: "Śmieci",
    type: "garbage",
    isCost: true,
  },
  {
    id: "5a1ba3c4-4571-478e-955f-cc7fdcbac9f3",
    name: "Ubezpieczenie",
    type: "insurance",
    isCost: true,
  },
  {
    id: "cbf0af19-26c3-4d56-9814-cf55fd855fc7",
    name: "Przychód z najmu",
    type: "rentalIncome",
    isCost: false,
  },
  {
    id: "64710858-bf4b-4182-9ca8-d25e32629df1",
    name: "Sprzedaż nieruch.",
    type: "sell",
    isCost: false,
  },
  {
    id: "846308a1-1953-4f9d-bbdc-e158448536d2",
    name: "Podatek od nieruch.",
    type: "propertyTax",
    isCost: true,
  },
  {
    id: "9ea54a21-c69f-4105-be62-e2b2d1a54cce",
    name: "Inny koszt",
    type: "otherCost",
    isCost: true,
  },
  {
    id: "455cf972-1a82-488c-911a-e483feebd110",
    name: "Zarządzanie najmem",
    type: "management",
    isCost: true,
  },
  {
    id: "ba2ec6cb-b0a7-4443-a0a4-e50c354f5c78",
    name: "Serwis",
    type: "service",
    isCost: true,
  },
  {
    id: "e4371316-608a-4ead-a1e9-e763385f6ae8",
    name: "Czynsz",
    type: "rent",
    isCost: true,
  },
  {
    id: "5c7950c8-27ea-49ee-b60e-e77c4724fcf2",
    name: "Koszty kredytu",
    type: "mortgage",
    isCost: true,
  },
];
